/**
 * @generated SignedSource<<e3ffda5c2dcff40eb5606d303f651462>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildEventsUpcomingCard_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventList_query">;
  readonly " $fragmentType": "GuildEventsUpcomingCard_query";
};
export type GuildEventsUpcomingCard_query$key = {
  readonly " $data"?: GuildEventsUpcomingCard_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildEventsUpcomingCard_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildEventsUpcomingCard_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventList_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "614930ae8a057ef77b68bfc8a5627825";

export default node;
